import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import useOnScreen from "./../../Helpers/isInView";
import picOne from "../../assets/heart-photos/1a.jpg";
import picTwo from "../../assets/heart-photos/2a.jpg";
import picThree from "../../assets/heart-photos/3a.jpg";
import picFour from "../../assets/heart-photos/4a.jpg";
import picFive from "../../assets/heart-photos/5a.jpg";
import picOneHeart from "../../assets/heart-photos/1b.jpg";
import picTwoHeart from "../../assets/heart-photos/2b.jpg";
import picThreeHeart from "../../assets/heart-photos/3b.jpg";
import picFourHeart from "../../assets/heart-photos/4b.jpg";
import picFiveHeart from "../../assets/heart-photos/5b.jpg";
import {useDispatch, useSelector} from "react-redux";
import {pics, setPics} from "../../features/counter/counterSlice";


const photoHearts = [
    picOneHeart,
  picTwoHeart,
  picThreeHeart,
  picFourHeart,
  picFiveHeart,
]

const photos = [
  {
    id: 0,
    title: 1,
    url: picOne,
    xStart: "5%",
    xEnd: "45%",
    y: "6.5vw",
    scale: 1,
    delay: 0.4,
    zIndex: 9999,
    opacity: 1,
  },
  {
    id: 1,
    title: 2,
    url: picTwo,
    xStart: "60%",
    xEnd: "82%",
    y: "-3vw",
    scale: 0.85,
    delay: 0.8,
    zIndex: 111111,
    opacity: 1,
  },
  {
    id: 2,
    title: 3,
    url: picThree,
    xStart: "-35%",
    xEnd: "-15%",
    y: "17vw",
    scale: 0.82,
    delay: 1,
    zIndex: 111111,
    opacity: 1,
  },
  {
    id: 3,
    title: 4,
    url: picFour,
    xStart: "45%",
    xEnd: "82%",
    y: "18vw",
    scale: 0.8,
    delay: 0.5,
    zIndex: 111111,
    opacity: 1,
  },
  {
    id: 4,
    title: 5,
    url: picFive,
    xStart: "-28%",
    xEnd: "-2%",
    y: "1vw",
    scale: 0.7,
    delay: 0.8,
    zIndex: 111111,
    opacity: 1,
  },
];

const Pics = () => {
  const Pictures = useSelector(pics)
  const dispatch = useDispatch()
  const controls = [
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
  ];
  const controlTwo = [
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
  ];

  const ref = useRef();
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (isVisible && !Pictures) {
      dispatch(setPics())
      setTimeout(() => {
        for (let i = 0; i < photos.length; i++) {
          controls[i].set({
            opacity: 0,
            x: photos[i].xStart,
            scale: photos[i].scale,
            originZ: photos[i].zIndex,
          });
          controls[i].start({
            x: photos[i].xEnd,
            opacity: photos[i].opacity,
            transition: { duration: 1.2, delay: photos[i].delay },
          });
        }

      }, 200);
      setTimeout(() => {
        for (let i = 0; i < photos.length; i++) {
          controls[i].set({
            display: 'block',
            opacity: 1,
            x: photos[i].xEnd,
            scale: photos[i].scale,
            originZ: photos[i].zIndex,
          });
          controlTwo[i].set({
            display: 'block',
            opacity: 0,
            x: photos[i].xEnd,
            scale: photos[i].scale,
            originZ: photos[i].zIndex + 999,
          });
          controls[i].start({
            scale: [photos[i].scale + 0.03,photos[i].scale + 0.03,photos[i].scale],
            transition: { duration: .7, delay: photos[i].delay },
          });
          controlTwo[i].start({
            opacity: [0,0,1,1],
            scale: [photos[i].scale + 0.03,photos[i].scale + 0.03,photos[i].scale],
            transition: { duration: .7, delay: photos[i].delay },
          });
        }

      }, 1800);
    }
  }, [isVisible]);

  return (
    <div className="pics" ref={ref}>
      {
        photos.map((photo, i) => {
          return (
              <div key={i}>
            <motion.div
              className="pics__picture"
              animate={controls[photo.id]}
              key={photo.id}
              style={{
                opacity: 0,
                top: photo.y,
                zIndex: `${photo.id === 0 ? 9999 : 1}`,
              }}
            >
              <img src={photo.url} alt="" />
            </motion.div>
                <motion.div
                    style={{
                      opacity: 0,
                      top: photo.y,
                      zIndex: `${photo.id === 0 ? 9999 : 1}`,
                    }}
                    animate={controlTwo[i]}
                    className="pics__picture picZ">
                  <img src={photoHearts[i]} alt="" />
                </motion.div>
              </div>
          );
        })}
    </div>
  );
};

export default Pics;
